/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, OnChanges, OnDestroy } from '@angular/core';

import { ConfigService } from './../../services/config.service';
import { EditMode } from './../../model/edit-mode.interface';
import { EditModeService } from './../../services/edit-mode.service';
import { HttpStatus } from './../../model/http-status-enum.model';
import { LmsMenuService } from './../../services/lms-menu.service';
import { LmsModuleService } from './../../services/lms-module.service';
import { LocoDetail } from '../../model/loco-detail.model';
import { MenuItem } from './../../model/menu-item.model';
import { PageMode } from '../../model/page-mode.model';
import { PopupService } from '../../../core/services/popup.service';
import { RouteChangePopupService } from './../../services/route-change-popup.service';
import { RoutePopup } from '../../model/route-popup.model';
import { Tab } from './../../model/tab.model';
import { TrainData } from '../../model/train-data.model';
import { UtilService } from './../../services/util.service';

/**
 * @export
 * @class LmsBaseAppComponent
 * @implements {OnDestroy}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-base-app',
  template: ''
})
export class LmsBaseAppComponent implements OnDestroy, OnChanges {
  selectedTab: Tab;
  tabSubscription: any;
  dataSubscription: any;
  editModeSubscription: any;
  subTypes: any;
  configData: any;
  loadData: any;
  protected service: any;
  protected type: string;
  protected routePopup: RoutePopup = { status: false, message: '', nextUrl: '' };
  selectedLoco: LocoDetail;
  selectedLocoId: string;
  selectedTrain: TrainData;
  selectedTrainId: string;
  selectedStation: TrainData;
  selectedStationId: string;
  locoTrainId: string;
  locoStatusOpr: any;
  private editMode: EditMode = { status: false, message: 'hide popup', nextUrl: '', callback: function () { } };


  /**
   * Creates an instance of LmsBaseAppComponent.
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {PopupService} popupService
   * @memberOf LmsBaseAppComponent
   */
  constructor(
    protected configService: ConfigService,
    protected lmsMenuService: LmsMenuService,
    protected lmsModuleService: LmsModuleService,
    protected utilService: UtilService,
    protected editModeService: EditModeService,
    protected routeChangePopupService: RouteChangePopupService,
    protected popupService: PopupService
  ) {
    this.configData = this.configService.getConfigData();
    this.editModeSubscription = this.editModeService.editMode.subscribe(data => {
      setTimeout(() => {
        this.editMode = data;
      }, 10);
    });

  }
  /**
   * in this methodwe are handling tab which we will
   * use in train ,terminal and loco component
   * @param {any} callback
   * @memberOf LmsBaseAppComponent
   */
  init(callback) {
    this.configData = this.configService.getConfigData();
    this.tabSubscription = this.lmsModuleService.selectedTab.subscribe(data => {
      const lSelectedTab = data;
      if (lSelectedTab && lSelectedTab.type === this.type) {
        if (this.selectedTab && this.selectedTab.intervalIdArr) {
          delete this.selectedTab['intervalIdArr'];
        }
        if ((!this.selectedTab && lSelectedTab) ||
          ((this.selectedTab && lSelectedTab) &&
            ((JSON.stringify(this.sortObject(lSelectedTab))) !== JSON.stringify(this.sortObject(this.selectedTab))))
          && this.selectedTab.subType === lSelectedTab.subType) {
          this.selectedTab = lSelectedTab;
          const menuItem = <MenuItem>(this.lmsMenuService.getMenuItem(this.selectedTab.type));
          if (menuItem && menuItem.subTypes) {
            this.subTypes = menuItem.subTypes;
          }
          if (this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status !== this.configService.getConfigData().tabStatus.blank) {
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.refresh; 
            callback.call(this);
          } else if (this.selectedTab.type === 'Locomotive-Status' || this.selectedTab.type === 'Query-View' || this.selectedTab.type === 'Yard-Local') {
            callback.call(this);
          }
        }
      }
    });
    this.dataSet();
  }


  /**
   * @param {any} o
   * @returns
   * @memberOf LmsBaseAppComponent
   */
  sortObject(o) {
    const sorted = {};
    let key;
    const a = [];

    for (key in o) {
      if (o.hasOwnProperty(key)) {
        a.push(key);
      }
    }

    a.sort();

    for (key = 0; key < a.length; key++) {
      sorted[a[key]] = o[a[key]];
    }
    return sorted;
  }

  /**
   * @param {any} nextUrl
   * @memberOf LmsBaseAppComponent
   */
  showRoutePopup(nextUrl) {

    this.editMode['nextUrl'] = nextUrl;
    this.routeChangePopupService.updateRouteMode(this.editMode);

  }

  /**
   * @param {any} [nextUrl]
   * @memberOf LmsBaseAppComponent
   */
  hideRoutePopup(nextUrl?) {
    this.routeChangePopupService.updateRouteMode({ status: false, message: '', nextUrl: nextUrl });
  }

  /**
   * @memberOf LmsBaseAppComponent
   */
  goToNextRoute() {
    this.service.resetAll();
    this.routePopup['status'] = false;
    this.editModeService.setEditResetMode(true);
    this.editModeService.setEditMode({ status: false, message: '' });
    setTimeout(() => {
      this.hideRoutePopup();
      this.routeChangePopupService.goToNextRoute();
    }, 500);

  }

  /**
   * @private
   * @memberOf LmsBaseAppComponent
   */
  private dataSet() {
    if (this.service.loadData) {
      this.dataSubscription = this.service.loadData.subscribe(data => {
        const windowHeight = window.innerHeight;
        let heightToAdjust = 0;
        if (window.innerWidth < 1280) {
          heightToAdjust = 22;
        }
        const leftMenuItems = document.getElementById('leftMenuItems');
        if (windowHeight && leftMenuItems) {
          leftMenuItems.removeAttribute('style');
          leftMenuItems.style.maxHeight = (windowHeight) + 'px';
          leftMenuItems.style.minHeight = ' ' + (windowHeight - 36 - heightToAdjust) + 'px';
        }
        if (!this.utilService.isEmptyObject(data)) {
          if (data.httpStatus === HttpStatus.OK) {
            if (data && this.selectedTab && this.selectedTab.id && data.tabId && data.tabId === this.selectedTab.id) {
              this.loadData = data;
              if (this.selectedTab) {
                this.selectedTab.lastRefreshTime = this.loadData.refreshTime;
                this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.loaded;
                this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].message = '';
                if (this.selectedTab.tabSearchParameter.searchText) {
                  this.selectedTab.description = `${this.selectedTab.tabSearchParameter.searchText} - ${this.selectedTab.subType}`;
                }

                if (this.selectedTab.type === 'Query-View' && this.selectedTab.description.toLowerCase() === 'new tab') {
                  const date = new Date();
                  this.selectedTab.description = 'Query View - ' + ('0' + date.getHours().toString()).slice(-2) + ':' + ('0' + date.getMinutes().toString()).slice(-2) + ':' + ('0' + date.getSeconds().toString()).slice(-2);
                }

                if (this.selectedTab.type === 'Terminal' && this.selectedTab.subType === 'Status') {
                  this.service.setPendingListStatus(this.loadData);
                }

                this.updateTab(this.selectedTab);
              }
            }

          } else {

            this.selectedTab.description = this.configService.getConfigData().tab.defaultDescription;
            this.selectedTab.lastRefreshTime = '';
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].message = data.errorMessage;
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;

            this.updateTab(this.selectedTab);
          }
        }
      });
    }
  }
  /**
   * Invoked when update tab information in module service.
   * @param {Tab} tab
   * @memberOf LmsTrainComponent
   */
  public updateTab(tab: Tab) {
    this.lmsModuleService.updateSelectedTab(tab);
  }

  /**
   * @returns
   * @memberOf LmsBaseAppComponent
   */
  public isEditMode() {
    return this.editMode && this.editMode['status'];
  }
  /**
   * this method is used to show the context panel for train
   * when user right click on any train icon
   * @param {any} event
   * @memberOf LmsTerminalComponent
   */
  public showTrainContextMenu(event) {
    document.getElementsByTagName('body')[0].click();
    this.hideContextMenu('train');
    setTimeout(() => {
      const receivedMap: Map<string, any> = event;
      this.selectedTrain = receivedMap.get('trainData');
      this.selectedTrainId = receivedMap.get('trainId');
    }, 5);
  }

  /**
    * this method is used to show the context panel for locomotive
    * when user right click on any locomotive icon
    * @param {any} event
    * @memberOf LmsTerminalComponent
    */
  public showLocomotiveContextMenu(event) {
    document.getElementsByTagName('body')[0].click(); 
    this.hideContextMenu('right click');
    setTimeout(() => {
      const receivedMap: Map<string, any> = event;
      this.selectedLoco = receivedMap.get('locoData');
      const trainId: string = receivedMap.get('trainId');
      const header = receivedMap.get('header');
      const index = receivedMap.get('index');
      this.locoTrainId = (trainId && trainId.length > 5) ?
        trainId.substring(5, trainId.length) :
        '';
      this.locoStatusOpr = {
        trainIdentifier: this.locoTrainId,
        currentTerminal: this.selectedTab.tabSearchParameter.searchText,
        header: header
      };
      this.selectedLocoId = trainId + 'loco' + this.selectedLoco.locomotiveIdentifier + index + header;
      this.selectedLoco.renderContextMenu = true;
      this.selectedLoco.header = header;
    }, 5);

  }

  /**
  * this method is used to hide the context panel of locomotive/train
  * which comes in open state when user right click on locomotive/train
  * svg icon
  * @memberOf LmsTerminalComponent
  */
  hideContextMenu(msg: string) {
    this.selectedLoco = null;
    this.selectedLocoId = null;
    this.selectedTrain = null;
    this.selectedTrainId = null;
    this.selectedStation = null;
    this.selectedStationId = null;
    this.locoTrainId = '';
    this.locoStatusOpr = {};
  }
  /**
 * This method invoked when search for train information is performed.
 * @memberOf LmsTrainComponent
 */
  public search() {
    this.service.load(this.selectedTab);
  }
  /**
  * Clean the state of lifecycle hook.
  * @memberOf LmsTrainComponent
  */
  ngOnDestroy() {
    this.destroy();
  }

  /**
   * @memberOf LmsBaseAppComponent
   */
  ngOnChanges() {

  }

  /**
  * To check for numeric value.
  * @private
  * @param {string} value
  * @returns {boolean}
  * @memberOf LmsTerminalHandlingComponent
  */
  public isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {PageMode} pageMode
   * @memberOf LmsBaseAppComponent
   */
  public setPageMode(pageMode: PageMode) {
    if (pageMode) {
      this.popupService.setPageMode(pageMode.mode);
      this.popupService.setSubmitBtnId(pageMode.id);
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }
  }

  /**
   * @memberOf LmsBaseAppComponent
   */
  public resetPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
   * For cleanup purpose
   * @memberOf LmsBaseAppComponent
   */
  public destroy() {
    this.service.cleanBehaviourSubject();
    if (this.tabSubscription) {
      this.tabSubscription.unsubscribe();
    }
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    this.editModeSubscription.unsubscribe();
    this.selectedTab = null;
    this.tabSubscription = null;
    this.dataSubscription = null;
    this.subTypes = null;
    this.configData = null;
    this.loadData = null;
    this.service = null;
    this.type = null;
    this.selectedLoco = null;
    this.selectedLocoId = null;
    this.selectedTrain = null;
    this.selectedTrainId = null;
  }

}
